export const AreaY = {
  TOP: 'top',
  MIDDLE: 'middle',
  BOTTOM: 'bottom',
  NONE: 'none',
};

export const AreaX = {
  START: 'start',
  MIDDLE: 'middle',
  END: 'end',
  NONE: 'none',
};
